module.exports = __webpack_public_path__ + "img/upload-email-generic-fr.2ce4cd1e.webp";